exports.DEFAULT_ZERO_PRICE = {
  liabilityAmount: 0,
  parcelAmount: 0,
  amount: 0,
  taxAmount: 0,
  totalIncVatAmount: 0,
  voucherDiscount: 0,
};

exports.DEFAULT_ZERO_PRICES = {
  items: {},
  ...exports.DEFAULT_ZERO_PRICE,
};
